import {archiveGateway} from "@/config/env.uri";

export const uri = {
  user: {
    getSysUser: `${archiveGateway}/getSysUserByDPCMemberInfoCardNum/`,
    getUserMenu: `${archiveGateway}/system/menu/getCurUserMenuTree`,
  }
};



// WEBPACK FOOTER //
// ./src/api/uri/archiveUri/user.js